<template>
    <div class="resource-area">
        <div class="resource-header flex flex-vertical-center">
            <span>资料下载</span>
        </div>
        <div class="resource-container">
            <resource-download :resourceList="resourceList" />
        </div>
    </div>
</template>

<script>
import ResourceDownload from './ResourceDownload.vue';
export default {
    name: 'ResourceArea',
    components: { ResourceDownload },
    props: {
        resourceList: {
            type: Array,
            default: []
        }
    }
};
</script>

<style lang="scss" scoped>
.resource-area {
    height: 100%;
    position: relative;
}
.resource {
    &-header {
        height: 45px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 500;
        color: #bbbbbb;
        padding: 14px 16px;
        background: #2b2b2d;
        border-top: 1px solid #545454;
        border-bottom: 1px solid #545454;
        // margin-bottom: 14px;
    }
    &-icon {
        width: 19px;
        height: 19px;
        object-fit: contain;
        margin-right: 7px;
    }
    &-container {
        position: absolute;
        top: 47px;
        width: 100%;
        bottom: 0;
    }
}
</style>
